import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Inject,
  forwardRef,
  ViewChild,
  Output,
  AfterViewInit
} from '@angular/core';
import { SearchParcelDataActivity } from '../../../../../models/activities';
import {
  UntypedFormControl,
  AbstractControl,
  UntypedFormBuilder,
  Validators,
  UntypedFormGroup
} from '@angular/forms';
import {
  WorkflowContextService,
  DataService,
  Utilities,
  SecurityService
} from '../../../../../services';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import { SearchParcelDataCriteria } from '../../../../../models/search-parcel-data-criteria';
import { SearchParcelDataProvider } from '../../../../../services/search-parcel-data.service';
import { EsriMapComponent } from 'src/app/components/arcgis/esri-map/esri-map.component';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { GeomUtils } from 'src/app/components/arcgis/geom-utils';
import { MapService, Actions } from 'src/app/models';
import { MapImageLayerService } from 'src/app/components/arcgis/mapimagelayer.service';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { map } from 'rxjs/operators';
import { combineLatest, Observable, of } from 'rxjs';
import { ParcelNotesCellComponent } from './parcel-notes-cell.component';
import { LayoutService } from 'src/app/services/layout.service';
import { CommonTableComponent } from 'src/app/components/common/common-table/common-table.component';


@Component({
    selector: 'wm-search-parcel-data-activity-input',
    templateUrl: './search-parcel-data-activity-input.component.html',
    styleUrls: ['./search-parcel-data-activity-input.component.css'],
    standalone: false
})
export class SearchParcelDataActivityInputComponent extends ActivityView
  implements OnInit, AfterViewInit {
  @Input() activity: SearchParcelDataActivity;
  @Input() searchWorkfowApplications = false;
  @Input() hideResultsOnSelect = false;
  @Output() goNext: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() searched: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() form: UntypedFormGroup;
  // Added by Vipul on 04-02-2026
  trimmedResults: any[] = [];
  // End by Vipul on 04-02-2026

  searchParcelDataCriteria: SearchParcelDataCriteria;
  searchParcelIdCtl: AbstractControl;
  searchParcelOwnerNameCtl: AbstractControl;
  searchParcelAddressCtl: AbstractControl;
  publicNote: string;
  internalNote: string;
  notes: string;
  parcelId: string;
  isInternalUser = false;
  results: any[];
  canViewInternalParcelNotes: boolean;
  canManageParcelNotes: boolean;
  private queueMapZoomToPid = false;
  templateForPermitForm: boolean = false
  userId: string;
  activeTabId: string;
  get clientId(): string {
    return this._context.testAsData?.clientId ||  this._context.client?.id;
  }
  @ViewChild(EsriMapComponent, { static: false })
  private esriMap: EsriMapComponent;
selectedParcelForNotes: any;
  _cachedMapService: MapService;

  loading = false;
  @ViewChild('ParcelNotesModal', { static: false }) parcelNotesModal: ModalConfirmComponent;

  resultsText: string;

  constructor(
    public layoutService: LayoutService,
    private fb: UntypedFormBuilder,
    private _searchParcelDataService: SearchParcelDataProvider,
    private _mapImageLayerService: MapImageLayerService,
    @Inject(forwardRef(() => DataService)) private _dataSvc: DataService,
    @Inject(forwardRef(() => WorkflowContextService))
    private _context: WorkflowContextService
  ) {
    super();

      layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });

    this.searchParcelIdCtl = new UntypedFormControl('');
    this.searchParcelOwnerNameCtl = new UntypedFormControl('');
    this.searchParcelAddressCtl = new UntypedFormControl('');
  }
  private loadPermissions() {
    if (this.results && this.results.length > 0) {
      const result = this.results[0];

      this.canViewInternalParcelNotes =
        result['canViewInternalParcelNotes'] === '1' ? true : false;
      this.canManageParcelNotes =
        result['canManageParcelNotes'] === '1' ? true : false;
    }
  }

  myParcelSelected(e) {
    this.selectOneResult(e, true, true);
  }

  ngOnInit() {
    if (this._context.user) {
      this.userId = this._context.user.id;
    }
if (this.activity.model.selectedParcel && this.templateForPermitForm) {
    const sp = this.activity.model.selectedParcel as any;
    if (typeof sp.selected === 'string') {
      sp.selected = sp.selected === 'True' || sp.selected === 'true';
    }
  }
    this.form.addControl(
      'ParcelId',
      new UntypedFormControl(
        this.activity.parcelId,
        this.activity.model.isRequired
          ? Validators.required
          : Validators.nullValidator
      )
    );

    this.form.addControl(
      'ParcelGeometry',
      new UntypedFormControl(
        null,
        this.activity.model.isRequired &&
        this.activity.model.mapConfig &&
        this.activity.model.mapConfig.mapServiceId
          ? Validators.required
          : Validators.nullValidator
      )
    );

    this.searchParcelDataCriteria = new SearchParcelDataCriteria({
      maxResults: 200,
      searchParcelId: this.activity.model.parcelId,
      searchParcelOwnerName: '',
      searchParcelAddress: '',
      clientId: this.clientId
    });

    // if we load with a parcel id but don't have a selected parcel then this is an invalid parcel
    if (this.activity.model.parcelId && !this.activity.model.selectedParcel) {
      this.results = [];
    }

if (this.activity.model.selectedParcel) {
  const sel = this.activity.model.selectedParcel;
  this.queueMapZoomToPid = true;
  this.results = [sel];
  this.form.controls['ParcelId'].setValue(sel);

if (this.templateForPermitForm) {
  this.loadPermissions();
  this.trimmedResults = this.trimResultsByColumns(
    [sel],
    this.parcelTableColumns
  );
  // The radio in wm-common-table now reads row.selected directly,
  // matching the pattern used by checkboxes — no reference juggling needed.
  // trimResultsByColumns already sets selected: true on the matching row.
} else {
  this.selectOneResult(sel, false, false);
}
}

  }

  ngAfterViewInit() {
    var parcelIdInput = document.getElementById('parcelIdSearch');
    var ownerNameInput = document.getElementById('parcelOwnerSearch');
    var addressInput = document.getElementById('propertyAddressSearch');

    if (parcelIdInput) {
      parcelIdInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.searchByParcelId();
        }
      });
    }

    if (ownerNameInput) {
      ownerNameInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.searchByOwnerName();
        }
      });
    }

    if (addressInput) {
      addressInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.searchByAddress();
        }
      });
    }
  }

  async persistChildComponent() {
    if (this.activity) {
      this.activity.featureGeometryWKT = null;
    }
    return this.esriMap ? this.esriMap.persistChildComponent() : of();
  }


  async getParcelLayerInfo(): Promise<MapService> {
    if (!this._cachedMapService) {
      this._cachedMapService = await this._dataSvc
        .getMapService(this.activity.model.mapConfig.mapServiceId)
        .toPromise();
    }
    return this._cachedMapService;
  }

  async onMapLoaded() {
    if (this.esriMap) {
      const ms = await this.getParcelLayerInfo();
      await this.esriMap.enableFeatureSelection(
        ms.parcelLayer,
        ms.parcelLayerKeyField,
        false
      );

      if (this.queueMapZoomToPid) {
        this.queueMapZoomToPid = false;

        let parcelIds = [];

        if (this.activity.model.selectedParcel) {
          parcelIds = this.results
            .filter(
              r => r.parcelID === this.activity.model.selectedParcel.parcelID
            )
            .map((v, i) => v.parcelID);
          await this.esriMap.selectFeaturesOnMap(parcelIds, 'redlayer');
        } else {
          parcelIds = this.results.map((v, i) => v.parcelID);
          await this.esriMap.selectFeaturesOnMap(parcelIds, 'bluelayer');
        }
      }

      if(this.activity.featureGeometryWKT) {
        const keys = Object.keys(
          this.activity.featureGeometryWKT
        ).filter(f => f != '$id');
        const featureWkt: string[] = [];
        keys.forEach(k => {
          if (this.activity.featureGeometryWKT[k]) {
            this.activity.featureGeometryWKT[k].forEach(f => {
              if (f.item2) {
                featureWkt.push(f.item2);
              }
            });
          }
        });

        await this.esriMap.setReferenceData(featureWkt);
        await this.esriMap.zoomToInitialExtentFull();
      }

    }
  }

  search(
    searchCriteria: SearchParcelDataCriteria,
    selectResult = false,
    updateMap = false
  ) {
    this.searched.emit();
    this.loading = true;

    this.resultsText = 'Showing results for ';

    if (searchCriteria.searchParcelId) {
      this.resultsText += 'Parcel ID: ';
      this.resultsText += `<strong>${searchCriteria.searchParcelId}</strong>`;
    }

    if (searchCriteria.searchParcelOwnerName) {
      if (searchCriteria.searchParcelId) {
        this.resultsText += ', ';
      }

      this.resultsText += 'Property Owner: ';
      this.resultsText += `<strong>${searchCriteria.searchParcelOwnerName}</strong>`;
    }

    if (searchCriteria.searchParcelAddress) {
      if (searchCriteria.searchParcelId || searchCriteria.searchParcelOwnerName) {
        this.resultsText += ', ';
      }

      this.resultsText += 'Property Address: ';
      this.resultsText += `<strong>${searchCriteria.searchParcelAddress}</strong>`;
    }

    this._searchParcelDataService
      .getSearchParcelDataResults(searchCriteria)
      .subscribe(
        res => {
          this.loading = false;
          // results includes the header row, so filter it out
          this.results = res.filter((v, i) => i > 0);
          // Added by Vipul on 04-02-2026
          this.trimmedResults = this.trimResultsByColumns(
            this.results,
            this.parcelTableColumns
          );
          // End by Vipul on 04-02-2026
          this.loadPermissions();
          if (this.results.length === 1 && selectResult) {
            this.selectOneResult(this.results[0], updateMap);
          }
        },
        err => {
          this.resultsText = null;
          this.loading = false;
          throw err;
        }
      );
  }

  submitSearchParcelDataCriteria() {
    this.clearResults();

    this.search(this.searchParcelDataCriteria, false, true);
  }

  searchByParcelId() {
    if (this.searchParcelDataCriteria.searchParcelId) {
      this.clearResults();

      let searchByParcelIdCriteria = {...this.searchParcelDataCriteria};

      searchByParcelIdCriteria.searchParcelAddress = null;
      searchByParcelIdCriteria.searchParcelOwnerName = null;

      this.search(searchByParcelIdCriteria, false, true);
    }
  }

  searchByOwnerName() {
    if (this.searchParcelDataCriteria.searchParcelOwnerName) {
      this.clearResults();

      let searchByOwnerNameCriteria = {...this.searchParcelDataCriteria};

      searchByOwnerNameCriteria.searchParcelId = null;
      searchByOwnerNameCriteria.searchParcelAddress = null;

      this.search(searchByOwnerNameCriteria, false, true);
    }
  }

  searchByAddress() {
    if (this.searchParcelDataCriteria.searchParcelAddress) {
      this.clearResults();

      let searchByAddressCriteria = {...this.searchParcelDataCriteria};

      searchByAddressCriteria.searchParcelId = null;
      searchByAddressCriteria.searchParcelOwnerName = null;

      this.search(searchByAddressCriteria, false, true);
    }
  }

  clearResults() {
    this.results = [];
    this.trimmedResults = []; // Added by Vipul on 04-02-2026
    this.activity.model.selectedParcel = null;
    this.form.controls['ParcelId'].setValue(null);
  }

  // map interactions:
  onParcelsBeforeIdentifying() {
    this.clearResults();
    this.loading = true;
  }

  onParcelsIdentified(parcelIds: string[]) {
    if (parcelIds && this._context.client) {
      const search = new SearchParcelDataCriteria({
        maxResults: 200,
        clientId: this.clientId,
        searchParcelIds: parcelIds
      });

      this.search(search, true, false);
    } else {
      this.loading = false;
    }
  }

  onSearchMapTabChange(tce: NgbNavChangeEvent) {
    switch (tce.nextId) {
      case 'mapTab':
        this.switchToMapTab();
        break;
      case 'searchTab':
        this.switchToSearchTab();
        break;
    }
  }

  async selectOneResult(
    result: { [key: string]: string },
    updateMap: boolean,
    goNext = false
  ) {
    this.activity.model.selectedParcel = result;
    this.activity.model.selectedGeometryWkt = null;

    const parcelId = result.parcelID;

    this.form.controls['ParcelGeometry'].setValue(null);
    this.form.controls['ParcelGeometry'].updateValueAndValidity();

    if (this.activity.model.mapConfig.mapServiceId) {
      const apiUrl = Utilities.getRootURL();
      const url = `${apiUrl}/api/mapproxy/mapserver/${this.activity.model.mapConfig.mapServiceId}`;
      const ms = await this.getParcelLayerInfo();
      const geom = await this._mapImageLayerService.getParcelGeometryWgs84(
        parcelId,
        url,
        ms.parcelLayer,
        ms.parcelLayerKeyField
      );
      const wkt = geom != null ? GeomUtils.ArcGisGeomToWkt(geom) : null;
      this.activity.model.selectedGeometryWkt = wkt;

      this.form.controls['ParcelGeometry'].setValue('true');
      this.form.controls['ParcelGeometry'].updateValueAndValidity();
    } else {
      this.activity.model.selectedGeometryWkt = null;
    }

    this.form.controls['ParcelId'].setValue(result);

    if (this.esriMap && updateMap) {
      this.esriMap.selectFeaturesOnMap([parcelId], 'redlayer');
    }

    if (goNext) {
      this.goNext.emit(true);
    }
  }

  switchToMapTab() {
    this.queueMapZoomToPid = this.results && this.results.length > 0;
  }

  switchToSearchTab() {
    // NOOP
  }

  isParcelSelected(parcel: any) {
    return (
      this.activity.model.selectedParcel &&
      this.activity.model.selectedParcel.parcelID === parcel.parcelID
    );
  }

  showParcel(parcel: any) {
    return this.hideResultsOnSelect && this.activity.model.selectedParcel
      ? this.isParcelSelected(parcel)
      : true;
  }
  getParcelNote(parcelId: string) {
    this._dataSvc.getParcelNote(parcelId).subscribe(response => {
      this.internalNote = response.internalNote;
      this.publicNote = response.publicNote;
    });
  }

  updateValue(field: string, value: string): void {
    (this.searchParcelDataCriteria as any)[field] = value;
}


parcelTableColumns = [
  {
    key: 'selected',
   label: '',
   headerType:'text',
   cellType:'radio',

  },
  {
    key: 'parcelID',
    label: 'Parcel ID',
    headerType: 'text',
    cellType: 'text'
  },
  {
    key: 'address',
    label: 'Address',
    headerType: 'text',
    cellType: 'text'
  },
  {
    key: 'city',
    label: 'City',
    headerType: 'text',
    cellType: 'text'
  },
  {
    key: 'ownerName',
    label: 'Owner Name',
    headerType: 'text',
    cellType: 'text'
  },
  {
    key: 'acres',
    label: 'Acres',
    headerType: 'text',
    cellType: 'text'
  },
 {
  key: 'notes',
  label: 'Notes',
  headerType: 'text',
  cellType: 'component',
  component: ParcelNotesCellComponent,
  width: '140px',
  componentInputs: (row: any) => ({
    row,
    canManageParcelNotes: row.canManageParcelNotes,
    canViewInternalParcelNotes: row.canViewInternalParcelNotes
  }),
  componentOutputs: {
    notesClick: (row: any) => this.openParcelNotes(row)
  }
}

];




onParcelRowClick(row: any) {
if(this.templateForPermitForm){
  this.trimmedResults.forEach(r => r.selected = (r === row));
}
  this.selectOneResult(row, true);
}


// trimResultsByColumns(data: any[], columns: any[]) {
//   if (!data) return [];
//   console.log('DATA: ', data);
//   console.log('COLUMNS: ', columns);
//   return data.map((item, index) => {
//     return columns.reduce((acc: any, col: any) => {
//       const key = col.key;

//     if (col.cellType === 'checkbox') {
//         acc[key] = false;
//       }
//       else if (col.cellType === 'radio') {
//        const sel = this.activity.model.selectedParcel;
//   acc[key] = !!(sel && sel.parcelID === item.parcelID);
//       }
//       else if (item.hasOwnProperty(key) && col.cellType !== 'component' && col.cellType !== 'radio' && col.cellType !== 'checkbox') {
//         if(key === 'acres'){

//           acc[key] = parseFloat(item[key]).toFixed(3);
//         }
//         else
//         {
//           acc[key] = item[key];
//         }
//       }


//       else if (col.cellType === 'component' && col.key === 'notes') {
//         acc['internalNote'] = item['internalNote'];
//         acc['publicNote'] = item['publicNote'];
//         acc['canViewInternalParcelNotes'] = this.canViewInternalParcelNotes;
//         acc['canManageParcelNotes'] = this.canManageParcelNotes;

//       }

//       return acc;
//     }, {});
//   });
// }

  trimResultsByColumns(data: any[], columns: any[]) {
    if (!data) return [];

    return data.map((item) => {
      return columns.reduce((acc: any, col: any) => {
        const key = col.key;

        if (col.cellType === 'checkbox') {
          acc[key] = false;
        }
        else if (col.cellType === 'radio') {
          const sel = this.activity.model.selectedParcel;
          acc[key] = !!(sel && sel.parcelID === item.parcelID);
        }
        else if (
          item.hasOwnProperty(key) &&
          col.cellType !== 'component' &&
          col.cellType !== 'radio' &&
          col.cellType !== 'checkbox'
        ) {
          if (key === 'acres') {
            acc[key] = parseFloat(item[key]).toFixed(3);
          } else {
            acc[key] = item[key];
          }
        }
        else if (col.cellType === 'component' && col.key === 'notes') {
          acc['internalNote'] = item['internalNote'];
          acc['publicNote'] = item['publicNote'];
          acc['canViewInternalParcelNotes'] = this.canViewInternalParcelNotes;
          acc['canManageParcelNotes'] = this.canManageParcelNotes;
        }

        return acc;
      }, { ...item });
    });
  }

openParcelNotes(row: any) {
  this.selectedParcelForNotes = row;

  this.parcelNotesModal.open();
}

bindNotesValue<K extends 'publicNote' | 'internalNote'>(key: K) {
  return (value: string) => {
    this[key] = value;
  };
}


  notesModal(publicNotes: string, internalNotes: string, parcelId: string) {
    publicNotes = publicNotes ? publicNotes : '';
    internalNotes = internalNotes ? internalNotes : '';
    this._dataSvc
      .saveParcelNote(publicNotes, internalNotes, parcelId)
      .subscribe(response => {});
  }
}
